import React, { useEffect, useState } from 'react';

const AboutMe: React.FC = () => {
  const [visibleCards, setVisibleCards] = useState<Set<number>>(new Set());

  useEffect(() => {
    const cards = document.querySelectorAll('.skill-card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        setVisibleCards(prev => new Set(Array.from(prev).concat(index)));
      }, index * 100);
    });
  }, []);

  const skills = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm2.5-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5z" />
        </svg>
      ),
      title: "FiveM Development & Car Moddeling",
      description: "Advanced server-side and client-side scripting for custom frameworks, jobs, and gameplay systems and creating cars for fivem."
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
        </svg>
      ),
      title: "Lua Scripting",
      description: "Expert-level Lua development for game logic, modular scripts, and performance-driven systems."
    },
  ];

  return (
    <section className="section" id="about">
      <div className="section-container">
        <h2 className="section-title">About Me</h2>
        <div className="about-me-content">
          <div className="about-me-avatar">
            <img src="https://images-ext-1.discordapp.net/external/2Y-0As7kKj-7yp9GrzNdxeIYwowfA_k6D1nXAzviX-w/%3Fsize%3D256/https/cdn.discordapp.com/avatars/1152373723249246218/9a56f659aa4b459970eeb58254010d2b.gif?width=115&height=115" alt="Profile Avatar" />
          </div>
          <div className="about-me-text">
            <h3>Hello, I'm Bretty.</h3>
            <p>
              Specialized in FiveM development, Lua, modern web tech, and custom vehicle modeling. I build immersive gaming experiences backed by scalable, high-performance architecture.
            </p>
            <p>
              Over the past 5 years, I've brought complex roleplay servers and custom frameworks to life. From designing intuitive, modern UI/UX to optimizing backend databases and configuring flawless vehicle handling via .meta files, I deliver complete, end-to-end solutions.
            </p>
          </div>
        </div>
        <div className="about-me-skills">
          <h3 className="skills-subtitle">Key Skills</h3>
          <div className="skills-grid-compact">
            {skills.map((skill, index) => (
              <div
                key={index}
                className="skill-card-compact"
                style={{
                  opacity: visibleCards.has(index) ? 1 : 0,
                  transform: visibleCards.has(index) ? 'translateY(0)' : 'translateY(30px)',
                  transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              >
                <div className="skill-icon-compact">
                  {skill.icon}
                </div>
                <div className="skill-content-compact">
                  <h4 className="skill-title-compact">{skill.title}</h4>
                  <p className="skill-desc-compact">{skill.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;